import React from 'react'
import PropTypes from 'prop-types'

import * as firebase from 'firebase'
import { connect } from 'react-redux'
import moment from 'moment'
import { InstantSearch, Configure } from 'react-instantsearch/dom'

import AlgoliaUtils from '../infra/AlgoliaUtils'
import JobScreen from './common/JobScreen.js'
import AddJobController from './common/AddJobController.js'
import ScheduleToolbar from './ScheduleToolbar'
import ScheduleOptionsPanel from './ScheduleOptionsPanel'
import ScheduleContentPanel from './ScheduleContentPanel'

import './Schedule.css'
import '../common/DayPickerStyle.css'

const WEEK_START_TYPE = 'week'

class Schedule extends React.Component {

  static propTypes = {
    userId: PropTypes.string.isRequired,
    teamId: PropTypes.string.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      jobInfo: false,
      dateStr: moment().format('YYYY-MM-DD'),
      selectedWorkers: [],
      searchMode: false
    }
  }

  getViewModeDbPath = () => {
    return `users/${this.props.userId}/settings/viewMode/${this.props.teamId}/scheduleViewMode`
  }

  componentDidMount() {
    firebase.database().ref(this.getViewModeDbPath()).on('value', this.onViewModeChanged)
  }

  componentWillUnmount() {
    firebase.database().ref(this.getViewModeDbPath()).off('value', this.onViewModeChanged)
  }

  onViewModeChanged = snapshot => {
    const value = snapshot.val()
    // default to day view if not set.
    if (!value || value === 'day') {
      this.setState({ viewMode: 'day' })
    }
    else {
      this.setState({ viewMode: value })
    }
  }

  updateViewMode = viewMode => {
    // update view mode value in DB with the user seletion.
    firebase.database().ref(this.getViewModeDbPath()).set(viewMode)
  }

  handleTodayClicked = () => {
    this.setState({
      dateStr: moment().format('YYYY-MM-DD')
    })
  }

  handleDayHeaderClicked = (viewMode, dateStr) => {
    this.updateViewMode(viewMode)
    this.setState({
      viewMode: viewMode,
      dateStr: dateStr
    })
  }

  handleDayClicked = day => {
    this.setState({
      dateStr: moment(day).format('YYYY-MM-DD')
    })
  }

  handleSelectedWorkersChanged = (selectedWorkers) => {
    this.setState({ selectedWorkers })
  }

  searchStateChange = searchState => {
    if (!searchState.query && this.state.searchMode) {
      this.setState({ searchMode : false })
    } else if (searchState.query && !this.state.searchMode){
      this.setState({ searchMode : true })
    }
  }

  handleDateChanged = (startDateStr, endDateStr) => {
    let dateStr = startDateStr
    if (this.state.viewMode === 'week') {
      if (moment().isBetween(startDateStr, endDateStr, null, '[]')) {
        dateStr = moment().format('YYYY-MM-DD')
      } else {
        dateStr = moment(startDateStr).startOf(WEEK_START_TYPE).format('YYYY-MM-DD')
      }
    }
    this.setState({ dateStr })
  }

  handleSearchReset = () => {
    this.setState({ searchMode : false })
  }

  render() {
    const algoliaCredentials = AlgoliaUtils.getCredentials()
    return (
      <div style={styles.container}>
        <InstantSearch
          className=".ais-InstantSearch__root"
          appId={algoliaCredentials.appId}
          apiKey={algoliaCredentials.apiKey}
          indexName={`${this.props.teamId}-events`}
          onSearchStateChange={this.searchStateChange}>
          <Configure hitsPerPage={500} />
          <ScheduleToolbar
            userId={this.props.userId}
            dateStr={this.state.dateStr}
            viewMode={this.state.viewMode}
            onTodayClicked={this.handleTodayClicked}
            onDateChanged={this.handleDateChanged}
            onSearchReset={this.handleSearchReset}
            onViewModeChanged={this.updateViewMode} />

          <div style={styles.content}>
            <ScheduleOptionsPanel
              dateStr={this.state.dateStr}
              viewMode={this.state.viewMode}
              onDayClicked={this.handleDayClicked}
              onSelectedWorkersChanged={this.handleSelectedWorkersChanged} />
            <ScheduleContentPanel
              dateStr={this.state.dateStr}
              viewMode={this.state.viewMode}
              searchMode={this.state.searchMode}
              selectedWorkers={this.state.selectedWorkers}
              onDayHeaderClicked={this.handleDayHeaderClicked} />
          </div>

          <JobScreen />
          <AddJobController />
        </InstantSearch>
      </div>
    )
  }
}

const styles = {
  container: {
    background: 'white',
    flexDirection: 'column',
    display: 'flex',
    width: '100%'
  },
  content:  {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    height: 'calc(100% - 48px)'
  }
}

const mapStateToProps = state => ({
  userId: state.firebase.userAuth.id,
  teamId: state.firebase.team.metadata.value.id
})

export default connect(mapStateToProps)(Schedule)



// WEBPACK FOOTER //
// ./src/schedule/Schedule.js